import { createContext } from 'react';

import type { DevControls } from '../dev/types.ts';

/**
 * The app's dev controls while dev mode is on (App.tsx), so every screen's ≡ menu can
 * open the dev tools. Undefined otherwise. Type-only: no dev code in the main bundle.
 */
export const DevContext = createContext<DevControls | undefined>(undefined);
